<button (click)="showMenu = !showMenu" class="reset menu-button">
  <ng-container
    [ngTemplateOutlet]="toggleTemplate() || defaultToggleTemplate"
    [ngTemplateOutletContext]="{ $implicit: showMenu }"
  />
</button>

<ng-template #defaultToggleTemplate let-open>
  <button class="reset">
    <span [hidden]="open" class="material-symbols-rounded-m">menu</span>
    <span [hidden]="!open" class="material-symbols-rounded-m">close</span>
    <span>{{ 'SOLUTIONS' | uppercase }}</span>
  </button>
</ng-template>

<ul class="solution-menu" [class.show-menu]="showMenu" [hidden]="!showMenu">
  @for (menuItem of menu; track menuItem.label) {
    <li>
      <a [class.disabled]="menuItem.hasAccess === false" [href]="menuItem.link" target="_blank">
        <img [src]="menuItem.src" width="70px" height="70px" />
        <div [innerHtml]="safeHtml(menuItem.label)" [class.no-access]="!menuItem.hasAccess"></div>

        @if (!menuItem.hasAccess) {
          <button target="_blank" class="try-btn">TRY IT OUT</button>
        }
      </a>
    </li>
  }
</ul>
